// src/components/Faq/Faq.jsx
import React, { useState, useMemo } from 'react';
import styles from './Faq.module.scss';

// props: { faqs: Array<{ q: string; a: string }>, title?: string, defaultOpen?: number }
export default function Faq({ faqs = [], title = 'FAQs', defaultOpen = -1 }) {
  const [openIndex, setOpenIndex] = useState(defaultOpen);
  const items = useMemo(() => faqs.filter(Boolean), [faqs]);

  if (!items.length) return null;

  return (
    <section className={`${styles.faq} mt-5`} aria-label={title}>
      <h2 className={styles.faq__title}>{title}</h2>
      <ul className={styles.faq__list}>
        {items.map((item, i) => (
          <li key={i} className={styles.faq__item}>
            <button
              className={styles.faq__question}
              aria-expanded={openIndex === i}
              aria-controls={`faq-panel-${i}`}
              id={`faq-header-${i}`}
              onClick={() => setOpenIndex(prev => (prev === i ? -1 : i))}
            >
              <span>{item.q}</span>
              <span className={styles.faq__icon}>{openIndex === i ? '−' : '+'}</span>
            </button>

            <div
              id={`faq-panel-${i}`}
              role="region"
              aria-labelledby={`faq-header-${i}`}
              className={`${styles.faq__answer} ${
                openIndex === i ? styles['faq__answer--open'] : ''
              }`}
            >
              <p>{item.a}</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
